import { getMoneyText } from "../../functions";

export interface IProductPriceProps {
  amount: number;
}

export default function Price({ amount: price }: IProductPriceProps) {
  let money = getMoneyText(price);
  return <>{`${money.amount} ${money.postFix}`}</>;
}
